import { useState, useEffect } from 'react'

// Start at 10 minutes and 43 seconds = 643 seconds
const INITIAL_TIME = 643

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME)

  useEffect(() => {
    // Check if we have a saved end time in localStorage
    const savedEndTime = localStorage.getItem('budines_offer_end_time')
    let endTime: number

    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10)
    } else {
      endTime = Date.now() + INITIAL_TIME * 1000
      localStorage.setItem('budines_offer_end_time', endTime.toString())
    }

    const updateTimer = () => {
      const now = Date.now()
      const remaining = Math.max(0, Math.floor((endTime - now) / 1000))
      setTimeLeft(remaining)
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)

    return () => clearInterval(interval)
  }, [])

  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60

    return {
      hours: h.toString().padStart(2, '0'),
      minutes: m.toString().padStart(2, '0'),
      seconds: s.toString().padStart(2, '0'),
    }
  }

  return formatTime(timeLeft)
}
